(function ($) {
	$(window).on('load', function () {
		let pagetop = '#pagetop';
		let footer = '.site-footer';

		$(pagetop).hide();
		$(footer).css('position', 'relative');

		$(window).on("scroll", function () {
			if ($(this).scrollTop() > 500) {
				$(pagetop).slideDown("fast");
			} else {
				$(pagetop).slideUp("fast");
			}
			let scrollHeight = $(document).height();
			let scrollPosition = $(window).height() + $(window).scrollTop();
			let footHeight = $(footer).innerHeight();
			if (scrollHeight - scrollPosition <= footHeight) {
				$(pagetop).css({//フッターに到達したら
					"position": "absolute",
					"bottom": footHeight + 1
				});
			} else { //フッターに到達する前
				$(pagetop).css({
					"position": "fixed",
					// "bottom": "0"
				});
			}
		});
		$(pagetop).on('click', function () {
			$('body,html').animate({
				scrollTop: 0
			}, 400);
			return false;
		});
	});

	// ページ内リンク（#access など）
	//
	// 以前はここに a[href^="#"] のクリック処理が2つあり、CSSの scroll-behavior: smooth と
	// あわせて1回のクリックで3つの動きが同時に走っていた。着地位置もヘッダー分ずれていた。
	// いまは着地位置の調整を CSS の scroll-padding-top に任せ、
	// スクロール自体もブラウザの標準にまかせている（JSからは何もしない）。
	//
	// ここで面倒を見るのは、外部から #付きURLで開かれた場合だけ。
	// スクロール出現の演出で本文が隠れたままだと目的地の位置が確定しないため、
	// 先に全部表示してから移動する。
	function jumpToHashOnLoad() {
		var hash = location.hash;
		if (!hash || hash === '#') return;

		var target;
		try {
			target = document.querySelector(hash);
		} catch (e) {
			return; // 不正なセレクタ（#! など）は無視
		}
		if (!target) return;

		// 演出待ちで高さが変わらないよう、先に出し切る
		document.querySelectorAll('.js-scrollin').forEach(function (el) {
			el.classList.add('is-show');
		});

		// 画像の読み込みで高さが変わることがあるので、描画が落ち着いてから移動する
		requestAnimationFrame(function () {
			requestAnimationFrame(function () {
				target.scrollIntoView();
			});
		});
	}

	if (document.readyState === 'complete') {
		jumpToHashOnLoad();
	} else {
		window.addEventListener('load', jumpToHashOnLoad);
	}
})(jQuery);
